<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
                <el-breadcrumb-item>我的創作</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div class="pre-word">標題:</div>
        <el-input class="title-input"  ></el-input>
        <div class="pre-word">表格:</div>

        <div>
          <div class="data-box">
            

            <div class="tab-data" style="margin-top:20px;">

              <template>
                <div style="min-height:500px;">
                  
                </div>

              </template>

            </div>

          </div>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      totaldata:'99999',
    };
  },
  methods: {
    //点击搜索按钮
    btnsearch(){

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    //获取当前条目ID号
    let id = this.$route.params.id;
    this.$http
      .get(`${this.$store.state.baseurl}/api/test/getDB?a=11`)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        this.dbdate = obj.dbinfo;
        this.bookinfo = obj.ebookInfo;
        this.editingInfo = obj.editingInfo;
        console.log(obj.dbinfo);
      });
  },
};
</script>



<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  .pre-word{
    margin-top: 15px;
    margin-bottom: 15px;

  }
  .title-input{
    width: 500px;

  }
  
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

</style>